import { API_GET, API_PUT } from "../config/axiosConfig";

/**
 * Fetches the current DCV streaming mode from the API
 * @returns {Promise<Object>} - Response containing the streaming mode configuration
 */
export async function getDcvStreamingMode() {
    try {
        const response = await API_GET(`${process.env.REACT_APP_CORE_API_URI}/web/dcv/check-stream`);
        return response.data;
    } catch (error) {
        console.error("Error fetching DCV streaming mode:", error);
        throw error;
    }
}

/**
 * Updates the DCV streaming mode via API
 * @param {boolean} isDcvStreamSource - Whether to use DCV as the streaming source
 * @returns {Promise<Object>} - Response from the API
 */
export async function updateDcvStreamingMode(isDcvStreamSource) {
    try {
        const data = {
            isDcvStreamSource
        };
        const response = await API_PUT(`${process.env.REACT_APP_CORE_API_URI}/web/dcv/check-stream`, data);
        return response.data;
    } catch (error) {
        console.error("Error updating DCV streaming mode:", error);
        throw error;
    }
}
